<template>
  <!-- TODO: make this work in show/hide mode? -->
  <b-container fluid>
    <b-row no-gutters>
      <template v-for="(editorField, i) in activeFields">
        <b-col :md="editorField.EditorSize ? editorField.EditorSize : 4" class="px-2"
          :key="'fieldListColumn-' + editorField.EditorFieldId"
        >
        <!-- TODO: put this in a "header" -->
        <!-- or go tabs! Why not! -->
          <editor-field
            :obj="obj" :originalObj="originalObj"
            :editorField="editorField"
            :parentObj="parentObj" :parentColumn="column"
            @changed="changed => onFieldChanged(i, changed)"
            @validated="valid => onFieldValidated(i, valid)"
            @update-value="(obj, column) => onFieldUpdated(obj, editorField)"
            :labelPosition="'top'"
            :addChildObject="addChildObject"
            :addChildObjects="addChildObjects"
            @save="(obj, section) => save(obj, section)"
            :removeChildObject="removeChildObject"
            :readdChildObject="readdChildObject"
            :readOnly="readOnly"
            :showAddButton="showAddButton"
          />
        </b-col>
      </template>
    </b-row>
    <b-row no-gutters v-if="availableFields.length > 0">
      <b-col class="px-4 pt-4">
        <b-form-group label-size="sm"
          label-class="font-weight-bold"
          label-cols="3"
          class=""
          v-if="hideBlank && !readOnly"
        >
          <template v-slot:label>
            Add Field <b-icon icon="plus-circle" variant="success"></b-icon>
          </template>
          <b-form-select
            :options="availableFields"
            text-field="DisplayName"
            value-field="EditorFieldId"
            @change="addField($event)"
            size="sm"
            autocomplete="off"
            />
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { LayoutPropertyColumn } from '@/store/editor/types'
import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import EditorFieldComponent from '@/components/editor/utility/editor-field.vue'

import MxEditorComponent from '@/mixins/editor-component'
import { EntityBase } from '@/store/types'
import { EditorField, EditorSection } from '@/store/entity/types'

@Component({
  components: {
    'editor-field': EditorFieldComponent,
  },
})
export default class extends Mixins(MxEditorComponent) {
  public changed = false
  public valid = true

  // simple array, since we don't add/remove fields on the fly, index doesn't change
  public changedFields: boolean[] = []
  public validatedFields: boolean[] = []

  // TODO: can we just use sectio.Fields?
  @Prop()
  public section!: EditorSection

  // @Prop()
  // public fields!: EditorField[] // the field we're editing

  @Prop()
  public column!: LayoutPropertyColumn // really the parentColumn, no?

  @Prop()
  public fieldCols!: number

  @Prop()
  public readdChildOject!: any

  @Prop({ default: true })
  public showAddButton!: boolean

  public activeFields: EditorField[] = []

  get hideBlank() {
    return this.section.Editor.HideBlankFields
  }

  // TODO: now to figure out where the actual data went?
  public mounted() {
    Vue.set(this, 'changedFields', new Array(this.section.Fields.length).fill(false))
    if (this.hideBlank) {
      this.activeFields = this.validFields.filter(c => {
        const value = this.obj ? this.obj[c.EntityProperty.PropertyName] : ''
        return value && value.length > 0
      })
      this.objChanged()
    } else {
      this.activeFields = this.validFields
    }
  }

  // TODO: this doesn't fire anymore? Is that right?
  @Watch('obj', { deep: true })
  public objChanged() {
    // TODO: multiple-editor-section and its wrapper object is a much better way!

    // TODO: defaultField list? How does that work now?
    // 1. Make this use defaultSectionTableColumns
    // 2. But this component isn't specific to Model Details!
    // 3. But we can work around this time around?

    // Note: Column Name is a decent match for the new EntityProperyName
    const defaultEntityPropertyNames = this.defaultSectionTableColumns?.map(stc => stc.ColumnName) || []
    this.availableFields.forEach(c => {
      const value = this.obj ? this.obj[c.EntityProperty.PropertyName] : ''
      if (value && value.length > 0) {
        this.addField(c.EditorFieldId)
      } else {
        if (defaultEntityPropertyNames.includes(c.EntityProperty.EntityPropertyName)) {
          this.addField(c.EditorFieldId)
        }
      }
    })
  }

  // TODO: is this the right method for this? just bubble?
  public onFieldUpdated(obj: EntityBase, editorField: EditorField) {
    this.$emit('update-item', obj, editorField)
  }

  public onFieldChanged(i: number, changed: boolean) {
    this.changedFields[i] = changed
    this.changed = this.changedFields.some(v => v)
    this.$emit('changed', this.changed, i)
  }

  public onFieldValidated(i: number, valid: boolean) {
    this.validatedFields[i] = valid
    this.valid = !this.validatedFields.some(v => !v)
    this.$emit('validated', this.valid, i)
  }

  public addField(editorFieldId: number) {
    const index = this.availableFields.findIndex(p => p.EditorFieldId === editorFieldId)
    this.activeFields.push(this.availableFields[index])
  }

  public recalculateActiveFields() {
    this.activeFields = this.validFields.filter(c => {
      const value = this.obj ? this.obj[c.EntityProperty.PropertyName] : ''
      return value && value.length > 0
    })
  }

  // the ones you can add
  get availableFields() {
    let availableFields = this.validFields
    // if (this.hideBlank) { // note: we don't use this if not hideBlank
    // where it isn't added already
    availableFields = availableFields.filter(c => this.activeFields.indexOf(c) === -1 && c.EffectivePermission.CanUpdate)
    // }
    return availableFields
  }

  // the ones that can be added or are already added
  get validFields() {
    return this.section.Fields // .filter(c => c.EditorType !== 'order')
  }

  public sectionMounted() {
    this.$emit('sectionMounted')
  }
}
</script>
<style scoped>
</style>
